/* wg-tab-order.js - Wade Greens
   Applies the PDP tab order published by sections/wg-tab-order.liquid as
   window.wgTabOrder: an array of keys in the order Devyn dragged the blocks
   in Customize.

   WHY A SCRIPT AND NOT LIQUID
   The six stock tabs are printed by sections/main-product.liquid, 140KB,
   past what the Admin API can write - their order cannot be changed at the
   source. It does not need to be. Measured live on the Snake Plant PDP, all
   seven tabs (the six stock ones plus the care tab that
   wg-product-care-tabs.js injects) are FLAT SIBLINGS: children 0-6 of one
   div.container.product-tabs. Everything else in that container - four
   scripts, a link, a noscript, a style and a 0-height faqs-item - sits after
   them and renders nothing.

   WHY DOM RE-INSERT AND NOT CSS FLEX ORDER
   Both were tested live and both put the tabs in the right order. flex lost:
     flex order     stack grew 980px -> 1010px. Adjacent margins stop
                    collapsing once the container is a flex box, so every
                    gap changed by ~4px.
     DOM re-insert  980px -> 980px, container stays display:block, spacing
                    pixel-identical to today.
   Re-inserting also survives the custom element: <product-tab> is a
   registered element, and MOVING a node (rather than cloning or re-writing
   innerHTML) keeps its listeners and state. Verified by opening and closing
   all seven tabs after a reorder - Description 115->213, Care 115->285,
   Pest Prevention 115->624, Growing Zone 115->808, Specifications 115->285,
   Q&A 115->374, Shipping 115->1085, every one closing again cleanly.

   A TRAP WORTH KEEPING: the accordion handle is the inner a.toggleLink, NOT
   .toggle-title. Clicking .toggle-title does nothing - on an untouched page
   too. A test that clicks the wrong element reports every tab as broken and
   looks exactly like a regression. Always sanity-check the control.

   MATCHING IS BY LABEL, NOT POSITION
   A tab whose metafield is empty never renders, so index 4 is not the same
   tab on every product. Each tab is identified by its heading text,
   normalised to letters and digits. ALIASES gives every key a few spellings
   so renaming a tab in the theme does not silently drop it from the order.

   THE pest-prevention KEY CARRIES 'pestwatch' AS AN ALIAS ON PURPOSE. The
   tab was called Pest Watch until Devyn renamed it; the metafield KEY is
   still custom.pest_watch because Shopify cannot rename a definition key.
   Keeping the old spelling in the alias list means the order holds whether a
   page renders the old heading or the new one, and it costs nothing.

   ANYTHING NOT LISTED FALLS TO THE BOTTOM in its original relative order, so
   a tab can never vanish because it was left out in Customize.

   READING THE LABEL: .toggle-title contains an inline <style> block as well
   as the text, so textContent yields "Description svg.larger-svg {width:...".
   The TreeWalker rejects anything inside style/script, which is why the
   labels come back clean.
*/
(function () {
  'use strict';

  var WRAP = '.container.product-tabs';

  var ALIASES = {
    'description':       ['description'],
    'specifications':    ['specifications', 'specs'],
    'care-instructions': ['careinstructions', 'care'],
    'growing-zone':      ['growingzone', 'zone'],
    'questions-answers': ['questionsanswers', 'qa', 'faq', 'faqs'],
    'shipping-returns':  ['shippingreturns', 'shipping'],
    'pest-prevention':   ['pestprevention', 'pestwatch'],
    'handling-keeping':  ['handlingkeeping', 'handling'],
    'plant-traits':      ['planttraits', 'traits']
  };

  // A block saved before the rename still says pest-watch. Fold it forward so
  // an old template keeps working without anyone having to re-drag anything.
  var KEY_ALIASES = { 'pest-watch': 'pest-prevention' };

  var lastApplied = '';

  function norm(s) {
    return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function labelOf(tab) {
    var h = tab.querySelector('.toggle-title') || tab.querySelector('[class*="title"]');
    if (!h) return '';
    var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        return n.parentElement && n.parentElement.closest('style,script')
          ? NodeFilter.FILTER_REJECT
          : NodeFilter.FILTER_ACCEPT;
      }
    });
    var out = '', n;
    while ((n = walker.nextNode())) out += n.nodeValue;
    return out;
  }

  function keyOf(tab) {
    var l = norm(labelOf(tab));
    if (!l) return null;
    for (var k in ALIASES) if (ALIASES[k].indexOf(l) !== -1) return k;
    return l;
  }

  function apply() {
    var wrap = document.querySelector(WRAP);
    if (!wrap) return false;

    var raw = Array.isArray(window.wgTabOrder) ? window.wgTabOrder : [];
    if (!raw.length) return true;
    var want = raw.map(function (k) { return KEY_ALIASES[k] || k; });

    var kids = [].slice.call(wrap.children);
    var tabs = kids.filter(function (c) { return c.tagName === 'PRODUCT-TAB'; });
    if (!tabs.length) return false;

    // Re-insert in front of the first non-tab child so the scripts, style and
    // faqs-item that follow the tab run are never disturbed.
    var anchor = null;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].tagName !== 'PRODUCT-TAB') { anchor = kids[i]; break; }
    }

    var present = tabs.map(keyOf);
    var signature = want.join('|') + '>>' + present.join('|');
    if (signature === lastApplied) return true;

    var byKey = {};
    tabs.forEach(function (t) {
      var k = keyOf(t);
      if (k) { byKey[k] = t; t.setAttribute('data-wg-tab', k); }
    });

    want.forEach(function (k) {
      if (byKey[k]) wrap.insertBefore(byKey[k], anchor);
    });
    // Unlisted tabs keep their original relative order, after the listed ones.
    tabs.forEach(function (t) {
      if (want.indexOf(keyOf(t)) === -1) wrap.insertBefore(t, anchor);
    });

    lastApplied = signature;
    return true;
  }

  function start() {
    if (apply()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (apply() || ++tries > 30) clearInterval(t);
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', apply);
  document.addEventListener('shopify:section:load', function () { lastApplied = ''; apply(); });

  // wg-product-care-tabs.js appends the care tab after this has already run.
  var mo = new MutationObserver(function () { apply(); });
  var wrapNow = document.querySelector(WRAP);
  if (wrapNow) mo.observe(wrapNow, { childList: true });
})();
